var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([01b]|1s|4p|a2|ef|ft|hm|j3|lc|ot|pe|qe|qi)|n([7bimq]|[9cw]5|0k|23|2u|57|bx|do|jx|ya|yr|ze)|2(57|7y|86|ci|d6|g3|hd|j|k4|s)|f([69lmwx]|2j|44|4t|bm|d3|n7|ob|pr|rd|sl|to|vi|wi|wn)|q([145bdewx]|15|4j|j7|k4|mc|v0|yb)|w([27ajv]|0q|1v|57|7i|a6|cf|gz|ry|s7|wb)|z([46acgmw]|0x|51|bi|dw|f4|n4|x5)|o([134inu]|4n|8t|dj|f6|fo|hu|uh|wz|xn|za|zc)|k([3fm]|ya(|a)|1f|1z|4h|89|jb|q9|r2|zb)|d([5egikz]|30|cm|f6|gb|nc|pi|v7)|l([bdqu]|cd|h5|i0|iy|sj|ym)|7([adgiju]|2[adg]|5z|a2|fa|gn|w3|y6)|b([3gz]|8f|am|bh|cn|kn|oc|sc|uw|vx|xt)|9([3aeglq]|87|9u|be|e6|id|j2|ls|mq|og|p9)|r([9gm]|02|7a|hk|j8|ku|n6|oo|q7|u5|xd|zx)|0([49djz]|1[5kq]|[aip]g|4y|aj|bc|gn|q9|vb|xz)|t(3a|3w|51|7lm|a6|ah|c|d|gm|ii|l3|llv|n9|ni|qd|qs|ty|ue)|i([1oqu]|r[4iz]|4i|5f|99|a2|ap|b6|c0|gs|ix|k4|kr|lh|lwb|nj|ns|wl)|x([39dlyz]|2y|4x|bv|gd|hy|jm|mx|rh|yc|zc)|h(a[58o]|1|4b|6|cx|g2|gj|j6|t8|up|wz|yz)|j([4ciqv]|29|7g|a4|dp|dv|pn|wb|wf)|3(71|92|b4|e|fl|h2h|hc|j3|r4|wj|z)|s([37cglr]|0a|61|bk|d9|ex|he|hs|kd|kj|me|tz|vp)|v([79fops]|k[dhn]|b3|ct|fa|n4|og)|1([1789fiotw]|00|f1|iz|jf|mu|qo|rv|td|w8|x7)|8([28ehuw]|(nm|q|x)c|1s|2x|e8|es|gu|hi|k2|ov|w4)|g(1|9s|lq|x|yb|yf|zt)|p([2ds]|3x|6o|n8|no|yv)|4([17hkv]|17|2a|76|7e|bi|eg|ft|j8|jx|uu|v5)|a([279w]|3u|7y|ck|cv|do|fc|ik|k3|n4|rf)|5([456kmux]|0s|1p|6n|7d|kk|rd|s9|zg)|c([248ek]|23|4t|8a|mi|n9)|6([3coquvz]|19|3t|8y|cd|fq|gc|v8|vyp|yb)|u((|u|w)8|2l|dt|gm|hn|wq)|e([9flrtwz]|2b|2f|5l|ah|av|mz|tk3|vi|vw|wo)|y([29jy]|7n|ek|g7|ji|kw|l8|zx))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
